import { useEffect } from "react";
import { notifyPageView } from "../../analytics/useAnalyticsEventTracker";
import { setMetaTags } from "../../helpers/pageMeta";
import { stateType } from "../../state";
import { LoadingDialog } from "../Common/LoadingDialog";
import { useStyles } from "../DataIngestion/DataIngestion";
import { CleanHeader } from "./CleanHeader";
import { AddFilterDropDown, SelectColDropDown } from "./FilterDataButton";
import { FilterHistogramBox } from "./FilterHistogramBox";
import { RowSelectTable } from "./RowSelectTable";
import { SelectedFilterIcons } from "./SelectedFilterIcon";

export function DataCleaning({ state }: stateType) {
	const classes = useStyles();
	useEffect(() => {
		setMetaTags();
		window.scrollTo(0, 0);
		notifyPageView("Data Cleaning Page", window.location.pathname);
	}, []);
	return (
		<div className={classes.root}>
			<div className={classes.grid}>
				<div className={classes.title}>Data Cleaning</div>
			</div>
			<div className={classes.grid}>
				<div className={classes.subTitle}>
					Remove outliers and bad data from your dataset to make it
					Machine Learning ready.
				</div>
			</div>

			<div className={classes.grid2}>
				<div
					style={{
						display: "flex",
						flexDirection: "row",
						marginTop: "20px",
						marginBottom: "-20px",
					}}
				>
					<div style={{ marginRight: "20px" }}>
						<SelectColDropDown state={state}></SelectColDropDown>
					</div>
					<AddFilterDropDown state={state}></AddFilterDropDown>
				</div>
				{<CleanHeader state={state}></CleanHeader>}
			</div>
			<div className={classes.grid2}>
				<SelectedFilterIcons state={state}></SelectedFilterIcons>
			</div>
			<div className={classes.divider2}></div>

			<div className={classes.grid}>
				<FilterHistogramBox state={state}></FilterHistogramBox>
			</div>
			<div className={classes.divider2}></div>
			<div className={classes.divider2}></div>
			<div className={classes.grid}>
				<div className={classes.title}>Remove Individual Rows</div>
			</div>
			<div className={classes.grid}>
				<RowSelectTable state={state}></RowSelectTable>
			</div>
			<div className={classes.grid}>
				<LoadingDialog state={state}></LoadingDialog>
			</div>
		</div>
	);
}
